import { Link, Outlet } from "react-router-dom";
import BrandLogo from "@/components/BrandLogo";

const NAV = [
  ["/games", "Games"],
  ["/how-to-play", "How to Play"],
  ["/guides", "Game Guides"],
  ["/fairness", "Fairness"],
  ["/blog", "Blog"],
  ["/about", "About"],
  ["/contact", "Contact"],
];
const LEGAL = [
  ["/terms", "Terms & Rules"],
  ["/privacy", "Privacy Policy"],
];

export default function MarketingLayout() {
  return (
    <div className="min-h-screen bg-[#07080D] text-white flex flex-col">
      <header className="sticky top-0 z-30 backdrop-blur-md bg-[#07080D]/80 border-b border-white/10">
        <div className="max-w-5xl mx-auto px-5 h-16 flex items-center justify-between">
          <BrandLogo size="header" withWordmark wordmarkClass="text-xl" testid="marketing-logo" />
          <nav className="hidden sm:flex items-center gap-6 text-sm text-gray-300">
            {NAV.map(([to, label]) => (
              <Link key={to} to={to} data-testid={`marketing-nav-${to.slice(1)}`} className="hover:text-white transition-colors duration-200">{label}</Link>
            ))}
          </nav>
          <Link to="/" data-testid="marketing-play-cta" className="px-4 py-2 rounded-xl bg-gradient-to-r from-amber-500 to-purple-600 text-sm font-semibold hover:opacity-90 transition-opacity duration-200">Play Now</Link>
        </div>
      </header>

      <main className="flex-1 max-w-3xl mx-auto px-5 py-12 w-full">
        <Outlet />
      </main>

      <footer className="border-t border-white/10 pt-6 pb-24 sm:pb-6 text-center text-xs text-gray-600 px-5">
        <div className="flex justify-center mb-4"><BrandLogo size="footer" testid="marketing-footer-logo" /></div>
        <div className="flex flex-wrap items-center justify-center gap-4 mb-2">
          {NAV.map(([to, label]) => <Link key={to} to={to} className="hover:text-white transition-colors duration-200">{label}</Link>)}
          {LEGAL.map(([to, label]) => <Link key={to} to={to} data-testid={`marketing-footer-${to.slice(1)}`} className="hover:text-white transition-colors duration-200">{label}</Link>)}
        </div>
        <span data-testid="marketing-footer-text">© {new Date().getFullYear()} PhonePlay · Phone Play LLC · A Damani Holdings company. 5675 Jimmy Carter Blvd, Suite 725, Norcross, GA 30071. Fun coins have no monetary value. 18+. Play responsibly.</span>
      </footer>
    </div>
  );
}
